const array = [
  {
    path: '/administrador/eventos/conf/aprovation/:id',
    name: 'event_conf_participants_aprovation',
    props: true,
    component: () => import('./pages/EventConfParticipantsAprovation.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Solicitações de participação',
      breadcrumb: [
        {
          text: 'Listagem de solicitaçõse',
          active: true,
        },
      ],
    },
  },

]

export default array
